import {convertToSlug} from '../api/utils';


export default defineNuxtPlugin(()=> {
    const appPath = (appId, appTitle) => {
      return `/apps/partner/${convertToSlug(appTitle)}/${appId}`;
    }
  const manageDetailPath = (appId) =>{
    return `/apps/manage/${appId}`
  }
  const appMentPath=(appId,appTitle)=>{
    return `/mp/${convertToSlug(appTitle)}/${appId}`
  }
    return {
      provide: {
        apps:{
            appPath,
            manageDetailPath,
            appMentPath
        },
      },
    };
});
